__turbopack_context__.v({
  "Usp": "UspBlock-module__0A3-IG__Usp",
  "UspBlock": "UspBlock-module__0A3-IG__UspBlock",
  "Usp__arrow": "UspBlock-module__0A3-IG__Usp__arrow",
  "Usp__description": "UspBlock-module__0A3-IG__Usp__description",
  "Usp__image": "UspBlock-module__0A3-IG__Usp__image",
  "Usp__title": "UspBlock-module__0A3-IG__Usp__title",
  "Usps": "UspBlock-module__0A3-IG__Usps",
  "text-center": "UspBlock-module__0A3-IG__text-center",
  "text-left": "UspBlock-module__0A3-IG__text-left",
  "text-right": "UspBlock-module__0A3-IG__text-right",
});
